import script from "./base-slide-over.vue?vue&type=script&setup=true&lang=js"
export * from "./base-slide-over.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__